var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoMenuWhile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.04876 19.9412H26.8888C27.6188 19.9412 28.1288 20.6712 27.8688 21.3612C26.7688 24.2812 23.5088 28.5512 15.9688 28.5512C8.42876 28.5512 5.16876 24.2812 4.06876 21.3612C3.80876 20.6712 4.31876 19.9412 5.04876 19.9412Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0786 10.9711C19.5809 10.9711 20.7986 9.75334 20.7986 8.25113C20.7986 6.74891 19.5809 5.53113 18.0786 5.53113C16.5764 5.53113 15.3586 6.74891 15.3586 8.25113C15.3586 9.75334 16.5764 10.9711 18.0786 10.9711Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3088 17.3511C12.9933 17.3511 14.3588 15.9856 14.3588 14.3011C14.3588 12.6166 12.9933 11.2511 11.3088 11.2511C9.62432 11.2511 8.25879 12.6166 8.25879 14.3011C8.25879 15.9856 9.62432 17.3511 11.3088 17.3511Z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9787 18.8711C19.1219 18.8711 20.0487 17.9443 20.0487 16.8011C20.0487 15.6579 19.1219 14.7311 17.9787 14.7311C16.8355 14.7311 15.9087 15.6579 15.9087 16.8011C15.9087 17.9443 16.8355 18.8711 17.9787 18.8711Z",
    fill: "#FFFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3088 14.9811L25.9988 10.2911C25.9988 10.2911 26.9688 15.6711 21.3088 14.9811Z",
    fill: "#FFFFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3587 3.56112L10.6687 8.25112C10.6687 8.25112 9.69867 2.87112 15.3587 3.56112Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMenuWhile);
export default __webpack_public_path__ + "static/media/ico_menu_while.5afbf97b96b7d52ffed3ead43f1a1521.svg";
export { ForwardRef as ReactComponent };